import type { CSSProperties } from 'react';
import type { ThemeMode } from './theme';
import { BUILTIN_BUTTON_DARK, BUILTIN_BUTTON_LIGHT, BUILTIN_BUTTON_PADDING, BUILTIN_FONT_SIZE, type ResponseButtonRole } from './design-defaults';

/** "Already responded" accent colors — a separate, fixed palette per role/
 * mode, unrelated to the (since removed, § Nutzeranfrage) "Antwort-Buttons"
 * settings UI; never configurable. */
const ACTIVE_COLORS: Record<ThemeMode, Record<ResponseButtonRole, [string, string]>> = {
  light: {
    accepted: ['#86efac', '#14532d'],
    declined: ['#fca5a5', '#7f1d1d'],
    maybe: ['#fcd34d', '#78350f'],
  },
  dark: {
    accepted: ['#166534', '#86efac'],
    declined: ['#7f1d1d', '#fca5a5'],
    maybe: ['#78350f', '#fcd34d'],
  },
};

export function responseButtonStyle(role: ResponseButtonRole, active: boolean, theme: ThemeMode): CSSProperties {
  const builtin = theme === 'dark' ? BUILTIN_BUTTON_DARK : BUILTIN_BUTTON_LIGHT;
  const [backgroundColor, color] = active ? ACTIVE_COLORS[theme][role] : [builtin[role].bg, builtin[role].text];
  return {
    backgroundColor,
    color,
    fontSize: `${BUILTIN_FONT_SIZE}px`,
    padding: BUILTIN_BUTTON_PADDING,
    lineHeight: 1,
  };
}
